import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type ReportNodeFragment = { __typename?: 'ReportNode', id: string, carNumber?: string | null, crimeTime: any, issueTime: any, location?: string | null, reportNumber: string, source: Types.ComplaintsReportSourceChoices, car?: { __typename?: 'CarNode', id: string, number: string, color?: string | null, carSubModel: { __typename?: 'CarSubModelNode', name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', name: string, localName?: string | null } } } | null, driver?: { __typename?: 'DriverNode', id: string, phone?: string | null, name: string, email?: string | null } | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, title?: Types.CustomersCustomerTitleChoices | null } | null, deal?: { __typename?: 'DealNode', id: string, status?: Types.DealsDealStatusChoices | null } | null };

export const ReportNodeFragmentDoc = gql`
    fragment ReportNode on ReportNode {
  id
  carNumber
  crimeTime
  issueTime
  location
  reportNumber
  source
  car {
    id
    number
    color
    carSubModel {
      name
      localName
      carModel {
        name
        localName
      }
    }
  }
  driver {
    id
    phone
    name
    email
  }
  customer {
    id
    email
    name
    title
  }
  deal {
    id
    status
  }
}
    `;